import {Box, useTheme} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import classNames from 'classnames';
import type * as React from 'react';

type Props = {
    className?: string;
};

const InlineLoadingIndicator: React.FC<Props> = ({className}: Props) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                width: '100%',
                justifyContent: 'center',
                padding: theme.spacing(2, 0),
            }}
            className={classNames(className)}
        >
            <CircularProgress />
        </Box>
    );
};

export default InlineLoadingIndicator;
